// import {
// 	loginByEmail,
// 	logout,
// 	getInfo,
// 	getMenus,
// 	getRoleCode
// } from 'api/login';
// import {
// 	getToken,
// 	setToken,
// 	removeToken
// } from 'utils/auth';
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    // token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    menus: undefined,
    eleemnts: undefined,
    permissionMenus: undefined,
    setting: {
      articlePlatform: []
    },
    username: '',
    rolecode: '',
    id: '',
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus;
    },
    SET_ELEMENTS: (state, elements) => {
      state.elements = elements;
    },
    LOGIN_SUCCESS: () => {
      console.log('login success')
    },
    LOGOUT_USER: state => {
      state.user = '';
    },
    SET_PERMISSION_MENUS: (state, permissionMenus) => {
      state.permissionMenus = permissionMenus;
    },
    SET_USERNAME: (state, username) => {
      state.username = username;
    },
    SET_ROLECODE: (state, rolecode) => {
      state.rolecode = rolecode;
    },
    SET_ID: (state, id) => {
      state.id = id;
    }
  },
  actions: {
    addmenus ({ commit, state }) {
      let menus = [
        {
          c_turl: require('../../img/a.png'),
          sid: '1',
          sname: '合伙人目标',
          slink: '/system/parnerTarget',
          chlist: []
        },
        {
          c_turl: require('../../img/b.png'),
          sid: '2',
          sname: '计划管理',
          slink: '',
          chlist: [
            {
              c_turl: require('../../img/b1.png'),
              sid: '13',
              sname: '年计划管理',
              slink: '/plan/yearPlan'
            }
            , {
              c_turl: require('../../img/b2.png'),
              sid: '14',
              sname: '月计划管理',
              slink: '/plan/monthPlan'
            }]
        },
        {
          c_turl: require('../../img/c.png'),
          sid: '3',
          sname: '行为管理',
          slink: '/behavior/behaviorList',
          chlist: []
        },
        {
          c_turl: require('../../img/d.png'),
          sid: '4',
          sname: '总结管理',
          slink: '/summary/summaryList',
          chlist: []
        },
        {
          c_turl: require('../../img/e.png'),
          sid: '5',
          sname: '系统设置',
          slink: '',
          chlist: [
            {
              c_turl: require('../../img/e1.png'),
              sid: '41',
              sname: '行为分类管理',
              slink: '/behavior/behaviorSortList',
            },
            {
              c_turl: require('../../img/e2.png'),
              sid: '42',
              sname: '权重配置',
              slink: '/system/weightSet',
            }
          ]
        },
      ]
      commit('SET_PERMISSION_MENUS', menus);
    }

  }
  // 	actions: {
  // 		// 邮箱登录
  // 		LoginByEmail({
  // 			commit
  // 		}, userInfo) {
  // 			const username = userInfo.username.trim();
  // 			commit('SET_TOKEN', '');
  // 			commit('SET_ROLES', []);
  // 			commit('SET_MENUS', undefined);
  // 			commit('SET_ELEMENTS', undefined);
  // 			removeToken();
  // 			return new Promise((resolve, reject) => {
  // 				loginByEmail(username, userInfo.password).then(response => {
  // 					// console.log(777)
  // 					setToken(response.data);
  // 					commit('SET_TOKEN', response.data);
  // 					// getRoleCode(response.data).then(response => {
  // 					// 	// console.log(response.result.code)
  // 					// 	commit('SET_ROLECODE', response);
  // 					// });
  // 					// commit('SET_ROLECODE', "studentAdmin");
  // 					resolve();
  // 				}).catch(error => {
  // 					reject(error);
  // 				});
  // 			});
  // 		},

  // 		// 获取用户信息
  // 		GetInfo({
  // 			commit,
  // 			state
  // 		}) {
  // 			return new Promise((resolve, reject) => {
  // 				getInfo(state.token).then(response => {
  // 					const data = response;
  // 					// console.log("权限111")
  // 					// console.log(data)
  // 					commit('SET_ID', data.id);
  // 					commit('SET_ROLES', 'admin');
  // 					commit('SET_NAME', data.name);
  // 					commit('SET_AVATAR', 'http://git.oschina.net/uploads/42/547642_geek_qi.png?1499487420');
  // 					commit('SET_INTRODUCTION', data.description);
  // 					const menus = {};
  // 					// for (let i = 0; i < data.menus.length; i++) {
  // 					// 	menus[data.menus[i].code] = true;
  // 					// }
  // 					commit('SET_MENUS', menus);
  // 					const elements = {};
  // 					// for (let i = 0; i < data.elements.length; i++) {
  // 					// 	elements[data.elements[i].code] = true;
  // 					// }
  // 					commit('SET_ELEMENTS', elements);
  // 					// commit('SET_USERNAME', data.username);
  // 					resolve(response);
  // 				}).catch(error => {
  // 					reject(error);
  // 				});
  // 				getMenus(state.token).then(response => {
  // 				    // console.log("权限")
  // 				    // console.log(response)
  // 					response.sid = '00001';
  // 					response.sname = '应用管理系统';
  // 					let s = [];
  // 					s.push(response);
  // 					console.log(s);
  // 					commit('SET_PERMISSION_MENUS', s);
  // 				});
  // 				// getRoleCode(state.token).then(response => {
  // 				// 	commit('SET_ROLECODE', response);
  // 				// });
  // 				//SET_CODE
  // 				// commit('SET_CODE', data.username);
  // 			});
  // 		},

  // 		// 第三方验证登录
  // 		LoginByThirdparty({
  // 			commit,
  // 			state
  // 		}, code) {
  // 			return new Promise((resolve, reject) => {
  // 				commit('SET_CODE', code);
  // 				loginByThirdparty(state.status, state.email, state.code).then(response => {
  // 					commit('SET_TOKEN', response.data.token);
  // 					setToken(response.data.token);
  // 					resolve();
  // 				}).catch(error => {
  // 					reject(error);
  // 				});
  // 			});
  // 		},

  // 		// 登出
  // 		LogOut({
  // 			commit,
  // 			state
  // 		}) {
  // 			return new Promise((resolve, reject) => {
  // 				logout(state.token).then(() => {
  // 					commit('SET_TOKEN', '');
  // 					commit('SET_ROLES', []);
  // 					commit('SET_MENUS', undefined);
  // 					commit('SET_ELEMENTS', undefined);
  // 					commit('SET_PERMISSION_MENUS', undefined);
  // 					removeToken();
  // 					resolve();
  // 				}).catch(error => {
  // 					reject(error);
  // 				});
  // 			});
  // 		},

  // 		// 前端 登出
  // 		FedLogOut({
  // 			commit
  // 		}) {
  // 			return new Promise(resolve => {
  // 				commit('SET_TOKEN', '');
  // 				commit('SET_MENUS', undefined);
  // 				commit('SET_ELEMENTS', undefined);
  // 				commit('SET_PERMISSION_MENUS', undefined);
  // 				removeToken();
  // 				resolve();
  // 			});
  // 		},

  // 		// 动态修改权限
  // 		ChangeRole({
  // 			commit
  // 		}, role) {
  // 			return new Promise(resolve => {
  // 				commit('SET_ROLES', [role]);
  // 				commit('SET_TOKEN', role);
  // 				setToken(role);
  // 				resolve();
  // 			})
  // 		},
  // 		// 获取用户角色Code
  // 		GetRoleCode({
  // 			commit,
  // 			state
  // 		}) {
  // 			return new Promise((resolve, reject) => {
  // 				getRoleCode(state.token).then(response => {
  // 					commit('SET_ROLECODE', response);
  // 					resolve();
  // 				}).catch(error => {
  // 					reject(error);
  // 				});

  // 			});
  // 		},
  // 	}
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js